import React, {Fragment, useEffect, useRef, useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useDispatch, useSelector} from "react-redux";
import {setUpdateSparePartId, updateSparePart, clearErrors, getUnitOptions, getWarehouseOptions} from "../../actions/spare_part";
import Select from "react-select";
import {getSelectedOption} from "../../utils/hooks/getParams";
import {getFirmOptionsForManagers} from "../../actions/user";

const SparePartUpdateForm = () => {

    const dispatch = useDispatch();
    const {update_spare_part, error, loading, spare_parts, unit_options, warehouse_options} = useSelector(state => state.spare_part);
    const {firm_options} = useSelector(state => state.user);

    useEffect(() => {
        dispatch(getFirmOptionsForManagers());
        dispatch(getUnitOptions());
    }, [dispatch]);

    const formRef = useRef();
    const [firmOptions, setFirmOptions] = useState([]);
    const [warehouseOptions, setWarehouseOptions] = useState([]);

    useEffect(() => {
        let items = [];
        firm_options.forEach((item) => items.push({
            label: `${item.name}`,
            value: item.id
        }));
        setFirmOptions(items);
    }, [firm_options]);

    useEffect(() => {
        let options = [];
        warehouse_options.forEach((item) => options.push({
            label: item.name,
            value: item.id
        }));
        setWarehouseOptions(options);
    }, [warehouse_options]);

    const [inputs, setInputs] = useState({
        name: '',
        firm_id: '',
        warehouse_id: '',
        unit_id: '',
    });
    const [errors, setErrors] = useState({});

    // Populate form when update_spare_part changes
    useEffect(() => {
        if (update_spare_part) {
            setInputs({
                name: update_spare_part.name || '',
                firm_id: update_spare_part.warehouse?.firm_id || '',
                warehouse_id: update_spare_part.warehouse_id || '',
                unit_id: update_spare_part.unit_id || '',
            });
            
            // Load warehouses for the firm
            if (update_spare_part.warehouse?.firm_id) {
                dispatch(getWarehouseOptions({firm_id: update_spare_part.warehouse.firm_id}));
            }
        }
    }, [update_spare_part, dispatch]);

    const handleChange = e => {
        setErrors({});
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value}));
    };

    const handleSelect = (data, type) => {
        setErrors({});

        if (type.name === 'firm_id') {
            dispatch(getWarehouseOptions({firm_id: data.value}));
        }
        setInputs(prevState => ({...prevState, [type.name]: data.value}))
    };

    useEffect(() => {
        if (error && loading === false) {
            const errorsItems = error?.errors;
            let errorObject = {};
            if (error?.errors) {
                Object.keys(error?.errors)?.forEach((item, index) => errorObject[item] = errorsItems[item][0]);
                setErrors(errorObject);
            }
        }
    }, [error, loading]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {
            name: inputs.name,
            firm_id: Number(inputs.firm_id),
            warehouse_id: Number(inputs.warehouse_id),
            unit_id: inputs.unit_id,
        };
        dispatch(updateSparePart(update_spare_part.id, data));
    };

    useEffect(() => {
        if (spare_parts && spare_parts.length > 0) {
            dispatch(clearErrors());
            setErrors({});
        }
    }, [spare_parts, dispatch]);

    const closeModal = () => {
        dispatch(setUpdateSparePartId(null));
        dispatch(clearErrors());
        setErrors({});
    };

    let condition = false;
    if (update_spare_part !== null)
        condition = true;

    return (
        <Fragment>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Ehtiyot qismini tahrirlash</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-3 pb-4 mx-3">
                    <form onSubmit={handleSubmit} ref={formRef}>

                        <div className="mb-3">
                            <label htmlFor="name">Nomi</label>
                            <input
                                name="name"
                                className={'form-control'}
                                type="text"
                                value={inputs?.name || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                            />
                            <div className="error">
                                {errors?.name}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="firm_id">Firma</label>
                            <Select
                                name={'firm_id'}
                                options={firmOptions}
                                value={getSelectedOption(inputs?.firm_id, firmOptions)}
                                onChange={handleSelect}
                                placeholder="Tanlang"
                            />
                            <div className="error">
                                {errors?.firm_id}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="warehouse_id">Sklad</label>
                            <Select
                                name={'warehouse_id'}
                                options={warehouseOptions}
                                value={getSelectedOption(inputs?.warehouse_id, warehouseOptions)}
                                onChange={handleSelect}
                                placeholder="Tanlang"
                            />
                            <div className="error">
                                {errors?.warehouse_id}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="unit_id">Kirim o'lchov birligi</label>
                            <select name="unit_id"
                                    value={inputs?.unit_id || ''}
                                    id="unit_id"
                                    className="form-control"
                                    onChange={handleChange}
                            >
                                <option value="">Tanlang</option>
                                {
                                    unit_options.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                            <div className="error">
                                {errors?.unit_id}
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <Button className="w-50" variant="secondary" type="button" onClick={closeModal}>Bekor
                                qilish</Button>
                            <Button className="w-50" variant="primary" type="submit">Saqlash</Button>
                        </div>
                    </form>
                </Modal.Body>

            </Modal>
        </Fragment>
    );
};

export default SparePartUpdateForm;